export default "__VITE_PUBLIC_ASSET__ae944f38__"